import { get } from "../../services/api";
import {
  GET_DROPDOWN_FAILED,
  GET_DROPDOWN_SUCCESS,
} from "./Dropdown/DropdownTypes";

export function getDropDownFailedAction(data) {
  return {
    type: GET_DROPDOWN_FAILED,
    payload: data,
  };
}

export function getDropDownSuccessAction(data) {
  return {
    type: GET_DROPDOWN_SUCCESS,
    payload: data,
  };
}

export function getDropDown(token) {
  return async (dispatch) => {
    try {
      const res = await get(
        "https://portal.rapidresourcingltd.co.uk/api/lov",
        token
      );
      console.log("res", res);
      const candidateSources =
        res?.filter((itm) => itm?.type === "CANDIDATE_SOURCES") || [];
      const employmentTypes =
      res?.filter((itm) => itm?.type === "EMPLOYMENT_TYPE") || [];
      const candidateStatus = 
        res?.filter((itm) => itm?.type === "CANDIDATE_STATUS") || [];
      const companySources =
        res?.filter((itm) => itm?.type === "COMPANY_SOURCE") || [];
        const attendanceStatusList =
        res?.filter((itm) => itm?.type === "ATTENDANCE_STATUS") || [];
        const visaTypeList =
        res?.filter((itm) => itm?.type === "VISA_TYPE") || [];
      const jobTitle = res?.filter((itm) => itm?.type === "JOB_TITLE") || [];
      const qualification = res?.filter((itm) => itm?.type === "CANDIDATE_QUALIFICATION") || [];
      const skills = res?.filter((itm) => itm?.type === "SKILLS") || [];
      const jobType = res?.filter((itm) => itm?.type === "JOB_TYPE") || [];
      const natureOfBusiness = res?.filter((itm) => itm?.type === "NATURE_OF_BUSINESS") || [];
      const companyContacts = res?.filter((itm) => itm?.type === "COMPANY-CONTACTS") || [];
      const payRateTypes = res?.filter((itm) => itm?.type === "PAY_RATE_TYPE") || [];
      
      const candidateComplianceCriteriaQuestions =
        res?.filter(
          (itm) => itm?.type === "CANDIDATE_COMPLIANCE_CRITERIA_QUESTIONS"
        ) || [];
      const payload = {
        candidateSources,
        companySources,
        jobTitle,
        candidateStatus,
        candidateComplianceCriteriaQuestions,
        attendanceStatusList,
        employmentTypes,
        visaTypeList,
        qualification,
        skills,
        jobType,
        natureOfBusiness,
        companyContacts,
        payRateTypes
      };
      dispatch(getDropDownSuccessAction({...payload}));
    } catch (e) {
      dispatch(
        getDropDownFailedAction(
          "Something went wrong while fetching dropdown.."
        )
      );
    }
  };
}
